import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import { injectIntl, FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import shiftTimezone from 'tz-offsets';
import { STYLE_GUIDE } from 'constants/icons';
import { decorateWith, withName } from 'helpers/decorator';
import { deepExtract } from 'helpers/deep';
import { ga } from 'helpers/multitrack';
import { isEmpty } from 'helpers/verify';
import { schedulesShape } from 'redux/saga/entities/schedules.shape';
import copyToClipboard from 'helpers/copyToClipboard';
import createGoogleCalendarEventLink from 'helpers/createGoogleCalendarEventLink';
import { mapScheduleProperties } from '../Reservation.helpers';
import { messages } from './ModalStates.messages';
export var InviteAFriendUnwrapped =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(InviteAFriendUnwrapped, _PureComponent);

  function InviteAFriendUnwrapped(props) {
    var _this;

    _classCallCheck(this, InviteAFriendUnwrapped);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InviteAFriendUnwrapped).call(this, props));
    _this.state = {
      copyButtonClicked: false
    };
    _this.handleCalendarLink = _this.handleCalendarLink.bind(_assertThisInitialized(_this));
    _this.handleCopyLink = _this.handleCopyLink.bind(_assertThisInitialized(_this));
    _this.handleEmailLink = _this.handleEmailLink.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(InviteAFriendUnwrapped, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      /* eslint-disable no-unused-expressions */


      this.isReferralAvailable() ? this.trackEvent('Modal Shown', true) : this.trackEvent('Unavailable Modal Shown', true);
      /* eslint-enable no-unused-expressions */
    }
  }, {
    key: "generateEmailLink",
    value: function generateEmailLink() {
      var _this$props = this.props,
          intl = _this$props.intl,
          referral = _this$props.referral;
      var smsDefault = referral.referrer_copy.sms_default;
      var body = encodeURIComponent(smsDefault);
      var subject = encodeURIComponent(intl.formatMessage(messages.inviteAFriendEmailSubject));
      return "mailto:?subject=".concat(subject, "&body=").concat(body);
    }
  }, {
    key: "handleCopyLink",
    value: function handleCopyLink() {
      var _this2 = this;

      copyToClipboard('#modal-referral-campaign-shortened-url');
      this.setState({
        copyButtonClicked: true
      }, function () {
        _this2.timer = setTimeout(function () {
          return _this2.setState({
            copyButtonClicked: false
          });
        }, 2000);
      });
      this.trackEvent('Copy Share Link');
    }
  }, {
    key: "handleEmailLink",
    value: function handleEmailLink() {
      this.trackEvent('Email Share');
    }
  }, {
    key: "handleCalendarLink",
    value: function handleCalendarLink() {
      this.trackEvent('Add to Calendar');
    }
  }, {
    key: "isReferralAvailable",
    value: function isReferralAvailable() {
      return !isEmpty(this.props.referral);
    }
  }, {
    key: "trackEvent",
    value: function trackEvent(event) {
      var nonInteraction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props2 = this.props,
          eventSource = _this$props2.eventSource,
          schedule = _this$props2.schedule;
      ga('Invite-a-Friend', "".concat(eventSource, " - ").concat(event), schedule.id, null, {
        nonInteraction: nonInteraction
      });
    }
  }, {
    key: "renderReferralAvailable",
    value: function renderReferralAvailable() {
      var _this$props$referral$ = this.props.referral.referrer_copy,
          campaignTitle = _this$props$referral$.modal_title,
          campaignSubtitle = _this$props$referral$.modal_subtitle,
          referralUrl = _this$props$referral$.referral_url,
          fullUrl = _this$props$referral$.full_url;
      var copyButtonClicked = this.state.copyButtonClicked;
      var copyButtonText = copyButtonClicked ? messages.inviteAFriendTextCopied : messages.inviteAFriendTextCopy;
      return React.createElement("div", {
        className: "reservation--invite-a-friend__content"
      }, React.createElement("h5", {
        className: "reservation--invite-a-friend__content__title"
      }, campaignTitle), React.createElement("p", {
        className: "reservation--invite-a-friend__content__subtitle"
      }, campaignSubtitle), React.createElement("div", {
        className: "reservation--invite-a-friend__shortlink-form-group"
      }, React.createElement("div", {
        className: "grid grid--sm"
      }, React.createElement("div", {
        className: "grid__item 7/10"
      }, React.createElement("input", {
        id: "modal-referral-campaign-shortened-url",
        className: "ph0",
        value: referralUrl || fullUrl,
        type: "url",
        onClick: this.handleCopyLink
      })), React.createElement("div", {
        className: "grid__item 3/10"
      }, React.createElement("button", {
        className: "bt bt--width-full text-sm",
        onClick: this.handleCopyLink
      }, React.createElement(FormattedMessage, copyButtonText))))), React.createElement("div", {
        className: "reservation--invite-a-friend__text-divider"
      }, React.createElement("p", null, React.createElement(FormattedMessage, messages.inviteAFriendTextOr))), React.createElement("a", {
        className: "bt bt--primary bt--solid bt--lg",
        href: this.generateEmailLink(),
        onClick: this.handleEmailLink
      }, React.createElement(FormattedMessage, messages.inviteAFriendEmailInvite)));
    }
  }, {
    key: "renderReferralUnavailable",
    value: function renderReferralUnavailable() {
      var onModalClose = this.props.onModalClose;
      return React.createElement("div", {
        className: "reservation--invite-a-friend__content"
      }, React.createElement("h5", {
        className: "reservation--invite-a-friend__content__title"
      }, React.createElement(FormattedMessage, messages.inviteAFriendUnavailableTitle)), React.createElement("p", {
        className: "reservation--invite-a-friend__content__subtitle"
      }, React.createElement(FormattedMessage, messages.inviteAFriendUnavailableSubtitle)), React.createElement("button", {
        className: "mt bt bt--width-full bt--lg",
        onClick: onModalClose
      }, React.createElement(FormattedMessage, messages.inviteAFriendUnavailableCta)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          schedule = _this$props3.schedule,
          referral = _this$props3.referral;

      var _mapSchedulePropertie = mapScheduleProperties(schedule),
          address = _mapSchedulePropertie.address,
          description = _mapSchedulePropertie.description,
          endTime = _mapSchedulePropertie.endTime,
          imageUrl = _mapSchedulePropertie.imageUrl,
          klassName = _mapSchedulePropertie.klassName,
          startTime = _mapSchedulePropertie.startTime,
          timeZone = _mapSchedulePropertie.timeZone;

      var headerImage = this.isReferralAvailable() ? deepExtract('referrer_copy.modal_image_url', referral) : imageUrl;
      return React.createElement("div", {
        className: "reservation reservation--invite-a-friend"
      }, imageUrl && React.createElement("div", {
        className: "modal__header__img",
        style: {
          backgroundImage: "url(\"".concat(headerImage, "\")")
        }
      }), React.createElement("div", {
        className: "reservation--invite-a-friend__schedule"
      }, React.createElement("div", {
        className: "reservation--invite-a-friend__schedule__date-time-text"
      }, React.createElement(FormattedHTMLMessage, _extends({}, messages.inviteAFriendSchedule, {
        values: {
          startTime: shiftTimezone(startTime, timeZone) * 1000
        }
      }))), React.createElement("div", {
        className: "reservation--invite-a-friend__schedule__calendar"
      }, React.createElement("a", {
        className: "reservation--invite-a-friend__schedule__calendar-icon icon icon--add-cal",
        href: createGoogleCalendarEventLink(klassName, description, address, startTime, endTime),
        onClick: this.handleCalendarLink,
        rel: "noopener noreferrer",
        target: "_blank"
      }, React.createElement(Isvg, {
        className: "svg",
        uniquifyIDs: false,
        src: STYLE_GUIDE.calendar
      }, React.createElement(FormattedMessage, messages.confirmationAddToCalendar))))), this.isReferralAvailable() ? this.renderReferralAvailable() : this.renderReferralUnavailable());
    }
  }]);

  return InviteAFriendUnwrapped;
}(PureComponent);
InviteAFriendUnwrapped.propTypes = {
  eventSource: PropTypes.string.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  onModalClose: PropTypes.func.isRequired,
  referral: PropTypes.object,
  schedule: schedulesShape.isRequired
};
export var InviteAFriend = decorateWith(injectIntl, withName('InviteAFriend'))(InviteAFriendUnwrapped);